import { usePaginatedQuery } from 'react-query';
import { listCompanies } from 'src/services/api/companies';

function useListCompanies(query, enabled = true) {
  return usePaginatedQuery(['companies', query], (key, query) => listCompanies(query), { enabled });
}

export default useListCompanies;
